import Helper from './Helper';

class ChartTabs {
  constructor(config = {}) {
    const {
      tabs,
      tabsItem,
      tabsItemTextWrapper,
      tabsItemChartWrapper,
      tabsItemText,
      tabsItemChart
    } = config;

    this.tabs = [].slice.call(document.querySelectorAll(tabs));
    this.tabsItem = [].slice.call(document.querySelectorAll(tabsItem));
    this.tabsItemTextWrapper = [].slice.call(document.querySelectorAll(tabsItemTextWrapper))[0];
    this.tabsItemChartWrapper = [].slice.call(document.querySelectorAll(tabsItemChartWrapper))[0];
    this.tabsItemText = [].slice.call(document.querySelectorAll(tabsItemText));
    this.tabsItemChart = [].slice.call(document.querySelectorAll(tabsItemChart));
    this.tabsItemChartClass = tabsItemChart;
    this.tabsItemChartWrapperClass = tabsItemChartWrapper;

    this.tabsIds = new Array();
    this.activeId = new String();
    this.charts = new Object();

    if(this.tabs && this.tabs.length !== 0){
      this.buildChartTabs();
    }
  }

  buildChartTabs(){    
    this.setMaxHeight();

    this.tabsItem.forEach((tabItem, i) => {
      i == 0 ? i++ : Helper.removeFromDom(tabItem);
    });
    Helper.removeFromDom(this.tabsItemText[0]);
    Helper.removeFromDom(this.tabsItemChart[0]);
  
    this.tabsItemText.forEach((tabsItemText) => {
      let id = Math.random().toString(36).substr(2, 9);
      this.tabsIds.push(id);
      tabsItemText.setAttribute('data-tab-id', id);
      tabsItemText.addEventListener('click', () => {
        this.setChartToActive(id);
      });
      this.tabsItemTextWrapper.appendChild(
        tabsItemText
      );
    });

    this.tabsItemChart.forEach((tabsItemChart, i) => {
      tabsItemChart.setAttribute('data-chart-id', this.tabsIds[i]);
      this.charts[this.tabsIds[i]] = tabsItemChart;
    });

    this.setChartToActive(this.tabsIds[0]);

    window.addEventListener('resize', () => {
      this.resizeCharts();
    });
  }

  setMaxHeight(){  
    let chartsMaxHeight = 0;
    document.querySelectorAll(this.tabsItemChartClass).forEach((tabItemChart) => {
      if(tabItemChart.offsetHeight > chartsMaxHeight) chartsMaxHeight = tabItemChart.offsetHeight;
    });
    document.querySelector(this.tabsItemChartWrapperClass).style.height = chartsMaxHeight + "px";
  }

  setChartToActive(chartId, redrawHighChart = true){
    this.activeId = chartId;
    this.tabsItemChartWrapper.replaceChildren();
    
    let chartActive = this.charts[chartId];
    chartActive.style.opacity = 0;

    this.tabsItemChartWrapper.appendChild(chartActive);
    
    if(redrawHighChart){
      let highchartId = this.tabsItemChartWrapper.querySelector('.chart-wrapper > div:first-child').id;
      let highchart = document.getElementById(highchartId);
      let highchartInstance = Highcharts.charts[highchart.getAttribute('data-highcharts-chart')];
      let highchartOptions = highchartInstance.userOptions;
      highchartInstance.destroy();
      Highcharts.chart(highchartId, highchartOptions);
    }
    
    chartActive.style.transition = "opacity ease-out .7s";
    chartActive.style.opacity = 1;

    this.tabsItemText.forEach((tabItemText, i) => {
      tabItemText.classList.remove('ns-chart__text--active');
    });

    document.querySelector('p[data-tab-id="' + chartId + '"]').classList.add('ns-chart__text--active');
  }

  resizeCharts(){
    let running = false;
    if(!running){
      running = true;
      for (const [chartId, chart] of Object.entries(this.charts)) {
        if(chartId != this.activeId){
          chart.style.opacity = 0;
          chart.style.position = 'absolute';
          this.tabsItemChartWrapper.appendChild(chart);
        }
      }
      window.setTimeout(() => {
        this.setMaxHeight();
        this.setChartToActive(this.tabsIds[0], false);
        for (const [chartId, chart] of Object.entries(this.charts)) {
          chart.style.position = '';
        }
        running = false;
      }, 200);
    }
  }
}

export default ChartTabs;
